"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetContext = void 0;
var react_1 = require("react");
var defaultContextValue = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    redirectToState: function () { },
};
exports.WidgetContext = (0, react_1.createContext)(defaultContextValue);
